import UpdateCatalogModal from "./UpdateCatalogModal";

export default UpdateCatalogModal;
